import { useHistory } from 'react-router-dom';
// @ts-expect-error Untyped import
import { EVENTS } from '../../lib/usageTracker';
// @ts-expect-error Untyped import
import { trackEvent } from '../../lib/usageTracker';
import { useDispatch, useSelector } from 'react-redux';
// @ts-expect-error Untyped import
import { SEARCH } from '../../constants/reportFilters';
import { Flex } from 'foundations-components/components/Flex';
import { Text } from 'foundations-components/components/Text';
// @ts-expect-error Untyped import
import { selectFilters } from '../../selectors/reportsSelector';
import FormattedMessage from 'I18n/components/FormattedMessage';
// @ts-expect-error Untyped import
import { setReportsFilters } from '../../actions/reportsActions';
import { HR } from 'foundations-components/transitional/components/HR';
import FormattedReactMessage from 'I18n/components/FormattedReactMessage';
import { Box } from 'foundations-components/transitional/components/Box';
import { SEARCH_REFERRER_STORAGE_KEY } from '../../constants/globalSearch';
import { Badge } from 'foundations-components/transitional/components/Badge';
// @ts-expect-error Untyped import
import { selectGenerativeAIEnabled } from '../../selectors/aiSettingsSelector';
import { CloseButton } from 'foundations-components/transitional/components/CloseButton';
import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
const SearchHeader = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const hasAiSearchSettingsEnabled = useSelector(selectGenerativeAIEnabled);
  const filters = useSelector(selectFilters).toJS();
  const search = filters[SEARCH];
  const referrer = window.sessionStorage.getItem(SEARCH_REFERRER_STORAGE_KEY);
  const handleExitSearchClick = () => {
    trackEvent(EVENTS.clickExitSearch, {
      subscreen: 'global-search'
    });
    dispatch(setReportsFilters(Object.assign({}, filters, {
      [SEARCH]: undefined,
      offset: 0
    })));
    history.push(referrer || '/');
  };
  return /*#__PURE__*/_jsxs(Flex, {
    zIndex: 5,
    position: "sticky",
    insetBlockStart: '0',
    backgroundColor: "fill-surface-default",
    justifyContent: "space-between",
    flexDirection: "column",
    display: "flex",
    paddingBlockStart: "500",
    paddingBlockEnd: "0",
    paddingInline: "800",
    children: [/*#__PURE__*/_jsxs(Flex, {
      justifyContent: "space-between",
      inlineSize: "100%",
      alignItems: "center",
      children: [search ? /*#__PURE__*/_jsx(Text, {
        color: "text-core-subtle",
        children: /*#__PURE__*/_jsx(FormattedReactMessage, {
          message: 'reports.globalSearch.resultsForPlaceholder',
          options: {
            searchValue: /*#__PURE__*/_jsxs("strong", {
              children: [`"${search}"`, " "]
            })
          }
        })
      }) : /*#__PURE__*/_jsx(Text, {
        color: "text-core-subtle",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: hasAiSearchSettingsEnabled ? 'reports.globalSearch.emptyState.searchPlaceholderAI' : 'reports.globalSearch.emptyState.searchPlaceholder'
        })
      }), /*#__PURE__*/_jsxs(Flex, {
        flexDirection: "row",
        alignItems: "center",
        justifyContent: "end",
        children: [/*#__PURE__*/_jsx(Box, {
          marginBlockEnd: "100",
          children: /*#__PURE__*/_jsx(Badge, {
            use: "beta",
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "reports.sidebar.badges.beta"
            })
          })
        }), /*#__PURE__*/_jsx(CloseButton, {
          color: "text-core-default",
          onClick: handleExitSearchClick,
          "data-test-id": "global-search-close-button",
          position: "relative",
          insetBlockStart: "0",
          insetInlineEnd: "0",
          marginInlineStart: "400"
        })]
      })]
    }), /*#__PURE__*/_jsx(HR, {
      marginBlockStart: "500",
      marginBlockEnd: "0"
    })]
  });
};
export default SearchHeader;